type PlanTier = "solo" | "practice";
type BillingCycle = "monthly" | "annual";

export interface PlanDefinition {
  key: PlanTier;
  name: string;
  description: string;
  monthlyPrice: string;
  annualPrice: string;
  priceSubtextMonthly: string;
  priceSubtextAnnual: string;
  monthlyPriceId: string;
  annualPriceId: string;
  includedLimits: {
    reports: string;
    insight: string;
    seats: string;
  };
  features: string[];
}

const env = import.meta.env;

export const BILLING_PLANS: Record<PlanTier, PlanDefinition> = {
  solo: {
    key: "solo",
    name: "Solo",
    description: "For individual radiologists",
    monthlyPrice: "$99",
    annualPrice: "$83",
    priceSubtextMonthly: "/month",
    priceSubtextAnnual: "/mo billed annually",
    monthlyPriceId: env.VITE_STRIPE_PRICE_SOLO_MONTHLY || "price_solo_monthly",
    annualPriceId: env.VITE_STRIPE_PRICE_SOLO_ANNUAL || "price_solo_annual",
    includedLimits: {
      reports: "Unlimited reports",
      insight: "Unlimited LiveInsight queries",
      seats: "1 seat",
    },
    features: [
      "All templates + customization",
      "Full macro console",
      "HIPAA-aligned workflows",
      "Email support (48h)",
      "Clean report export",
    ],
  },
  practice: {
    key: "practice",
    name: "Practice",
    description: "For groups of 2-20 radiologists",
    monthlyPrice: "$79",
    annualPrice: "$66",
    priceSubtextMonthly: "/seat/month",
    priceSubtextAnnual: "/seat/mo billed annually",
    monthlyPriceId: env.VITE_STRIPE_PRICE_PRACTICE_MONTHLY || "price_practice_monthly",
    annualPriceId: env.VITE_STRIPE_PRICE_PRACTICE_ANNUAL || "price_practice_annual",
    includedLimits: {
      reports: "Unlimited reports",
      insight: "Unlimited LiveInsight queries",
      seats: "2-20 seats",
    },
    features: [
      "Everything in Solo",
      "Shared team templates",
      "Shared macro library",
      "Priority support (24h)",
      "Quarterly audit export",
    ],
  },
};

export function getPriceId(plan: PlanTier, cycle: BillingCycle): string {
  return cycle === "annual"
    ? BILLING_PLANS[plan].annualPriceId
    : BILLING_PLANS[plan].monthlyPriceId;
}

